import { createFileRoute, redirect } from '@tanstack/react-router'
import { CreditNoteCreateScreen } from '@/features/accounting-document-create/document-create-screen'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/accounting/credit-notes/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_invoice.create'))
      throw redirect({ to: '/accounting/invoices' })
  },
  component: CreditNoteCreateScreen,
})
